"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionResponseToJSON = exports.VersionResponseFromJSONTyped = exports.VersionResponseFromJSON = void 0;
function VersionResponseFromJSON(json) {
    return VersionResponseFromJSONTyped(json, false);
}
exports.VersionResponseFromJSON = VersionResponseFromJSON;
function VersionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'version': json['version'],
    };
}
exports.VersionResponseFromJSONTyped = VersionResponseFromJSONTyped;
function VersionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'version': value.version,
    };
}
exports.VersionResponseToJSON = VersionResponseToJSON;
